import { render, staticRenderFns } from "./DetalleLiquidacion.vue?vue&type=template&id=41696663"
import script from "./DetalleLiquidacion.vue?vue&type=script&lang=js"
export * from "./DetalleLiquidacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports